import { render, staticRenderFns } from "./teachingProgressAdd.vue?vue&type=template&id=025db4ba&scoped=true&"
import script from "./teachingProgressAdd.vue?vue&type=script&lang=js&"
export * from "./teachingProgressAdd.vue?vue&type=script&lang=js&"
import style0 from "./teachingProgressAdd.vue?vue&type=style&index=0&id=025db4ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025db4ba",
  null
  
)

export default component.exports